/**
 * Created by xinjundong on 2017/11/20.
 */
import {androidUrl, iosUrl, androidWXURL} from './address'
import {gets} from './dom'
import '../video/inc-all'
/**
 * 获取一个随机字符串
 * */
export function getRandomStr (str) {
  return str + '_' + String((new Date()).getTime() * Math.random()).substr(0, 13).replace('.', 'a')
}

/**
 * 格式化时间
 * */
export function formatTime (v) {
  var today = new Date();
  var dateObj = new Date(v);
  var year = dateObj.getFullYear();
  var month = dateObj.getMonth();
  var date = dateObj.getDate();
  var hours = dateObj.getHours();
  var minute  = dateObj.getMinutes();
  var ty = today.getFullYear();
  var tm = (today.getMonth()+1);
  var td = today.getDate();
  var th = (today.getHours()+1);
  var tmn = (today.getMinutes()+1);
  month +=1;
  hours +=1;
  minute +=1;

  var month1 = (month < 10) ? '0'+month : month;
  var	date1 = (date < 10) ? '0'+date : date;
  var	hours1 = (hours < 10) ? '0'+(hours-1) : (hours-1);
  var	minute1 = (minute < 10) ? '0'+minute : minute;
  if(ty == year && tm == month) {

    if( td == date) {
      if(hours == th) {
        var mstr = tmn - minute;
        if(mstr == 0) {
          return '一分钟前';
        } else {
          return mstr+'分钟前';
        }
      } else {
        return '今天&nbsp;'+hours1+':'+minute1;
      }

    } else if(td - date == 1) {
      return '昨天&nbsp;'+hours1+':'+minute1;
    } else {
      return month1+'-'+date1+'&nbsp;'+hours1+":"+minute1;
    }
  } else {
    return year+'-'+month1+'-'+date1+'&nbsp;'+hours1+":"+minute1;
  }
}
/**
 * js 打开 app
 * */
export function openApp (id) {
  let openAppUrl
  if (id) {
    openAppUrl = 'sohuauto://sohuauto.auto.sohu.com/news/textNewsDetail?newsId=' + id
  } else {
    openAppUrl = 'sohuauto://sohuauto.auto.sohu.com/app/splash'
  }
  let uaStr = navigator.userAgent.toLowerCase()
  if (uaStr.match(/(iphone|ipod|ipad);?/i)) {
    // let loadDateTime = new Date()
    // window.setTimeout(function () {
    //   let timeOutDateTime = new Date()
    //   if (timeOutDateTime - loadDateTime < 5000) {
    //     window.location.href = iosUrl
    //   }
    //   // } else {
    //   //   window.close()
    //   // }
    // }, 25)
    if(id) {
      openAppUrl ='https://oia.auto.sohu.com/articles/'+id;
    } else {
      openAppUrl ='https://oia.auto.sohu.com/articles/';
    }
    window.location.href = openAppUrl;
  } else if (uaStr.match(/android/i)) {
    if (uaStr.indexOf('micromessenger') > -1) {
      window.location.href = androidWXURL
    } else {
      window.location.href = openAppUrl
      setTimeout(function () {
        window.location.href = androidUrl
      }, 200)
    }
  }
}

// 加载视频

export function loadVideo () {
   var videoDoms = gets('.video-box');
  Array.prototype.forEach.call(videoDoms, function(el, i) {
    var videoBid = el.getAttribute('data-bid');
    playerFactory.createPlayer(`[data-bid="${videoBid}"]`, {
      autoplay: false,
      mtvSrc: 10010001,
      data: {
        vid: videoBid,
        site: 2
      }
    });
  });
}



// WEBPACK FOOTER //
// ./src/api/utils/funcs.js